export default __webpack_public_path__ + "static/media/Axe_9.8478b5da.png";